import TextInput from "@scripts/react/components/TextInput";
import { useModel } from "@/contexts/ModelContext";
import { useComputedValues } from "@/contexts/ComputedValuesContext";
import { useIsGeneratingPredictions } from "@/hooks/useIsGeneratingPredictions";
import { useFlow } from "@/contexts/FlowContext";

export const TextPrompt = () => {
    const { textPromptStr, setTextPromptStr } = useModel();
    const isGeneratingPredictions = useIsGeneratingPredictions();
    const { currentFramePredictions } = useComputedValues();
    const { isExtractingWithAI } = useFlow();

    return (
        <TextInput
            placeholder="Enter objects: person, card, dog..."
            disabled={
                isGeneratingPredictions || currentFramePredictions.length > 0 || isExtractingWithAI
            }
            value={textPromptStr}
            onChange={setTextPromptStr}
            fullWidth={true}
        />
    );
};
